<template>
<div class="withdraw-chanel-card">
  <div
    v-if="cardInfoFlag"
    class="payee-box">
    <div class="card-top">
      <img
        class="icon-img"
        :src="iconUrl"
        alt=""
      >
      <span class="name">{{cardFristText}}</span>



      <span class="theNameOfTheCurrency"  v-if="currentWithdrawInfo.payTypeId == 4">{{ currentWithdrawInfo.payDetailMap.currency }}</span>
    </div>
    <span class="trc20-text" v-if="currentWithdrawInfo.payTypeId == 5 || currentWithdrawInfo.payTypeId == 8">{{'TRC20'}}</span>
    <span class="trc20-text" v-if="currentWithdrawInfo.payTypeId == 6 || currentWithdrawInfo.payTypeId == 9">{{'OTC'}}</span>
    <div
      v-if="bottomLineFlag"
      class="bottom-line">
      <p>{{currentWithdrawInfo.payDetailMap.bankName}}</p>
    </div>
  </div>

  <!--没有绑定就显示添加,-->
  <div
    v-if="noInfoFlag"
    @click="addHandle"
    class="payee-box no-info pointer">
    <i
      class="el-icon-plus add-btn pointer"
    ></i>
    <span
      class="pointer"
    >{{$t('add')}}</span>
  </div>
</div>
</template>

<script>
import bankIconUrl from "@/assets/images/founds/bankTw.png";
import usdtIconUrl from "@/assets/images/founds/usdtIcon.png";
import otcIconUrl from "@/assets/images/founds/otcIconNew.png";

export default {
  name: "withdrawChanelCard",
  props: {
    currentWithdrawInfo: {
      type: Object,
      default(){
        return {

        }
      }
    },
  },
  created(){
    
  },
  computed: {
    iconUrl(){
      if(this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7){
        return bankIconUrl;
      }else if(this.currentWithdrawInfo.payTypeId == 5 || this.currentWithdrawInfo.payTypeId == 8){
        return usdtIconUrl;
      }else if(this.currentWithdrawInfo.payTypeId == 6 || this.currentWithdrawInfo.payTypeId == 9){
        return otcIconUrl;
      }
    },
    cardInfoFlag(){
      // 没有银行卡审核中的ui图
      if(this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7){
        if(this.currentWithdrawInfo.examineStatus == 2 || !this.currentWithdrawInfo.payDetailMap.bankAccount){
          return false;
        }else {
          return true;
        }
      }else if(this.currentWithdrawInfo.payTypeId == 5 || this.currentWithdrawInfo.payTypeId == 8){
        if(!this.currentWithdrawInfo.payDetailMap.address){
          return false;
        }else {
          return true;
        }
      }else if(this.currentWithdrawInfo.payTypeId == 6 || this.currentWithdrawInfo.payTypeId == 9){
        if(!this.currentWithdrawInfo.payDetailMap.address){
          return false;
        }else {
          return true;
        }
      }
    },
    noInfoFlag(){
      // 没有时,要添加
      return !this.cardInfoFlag;
    },
    cardFristText(){
      if(this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7){
        if (!this.currentWithdrawInfo.payDetailMap.bankAccount) {
          return this.$t('Unbound');
        } else {
          switch (this.currentWithdrawInfo.examineStatus) {
            case 1:
              return this.currentWithdrawInfo.payDetailMap.bankAccount + ` (${this.$t('User.authing')})`;
            case 2:
              return this.currentWithdrawInfo.payDetailMap.bankAccount + ` (${this.$t('User.custStatus4')})`;
            case 3:
              return this.currentWithdrawInfo.payDetailMap.bankAccount;
          }
        }
        // return this.currentWithdrawInfo.payDetailMap.bankAccount;
      }else if(this.currentWithdrawInfo.payTypeId == 5 || this.currentWithdrawInfo.payTypeId == 8){
        return this.currentWithdrawInfo.payDetailMap.address || this.$t('Unbound') ;
      }else if(this.currentWithdrawInfo.payTypeId == 6 || this.currentWithdrawInfo.payTypeId == 9){
        return this.currentWithdrawInfo.payDetailMap.address || this.$t('Unbound');
      }
    },
    bottomLineFlag(){
      // usd和otc购币不显示
      return this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7;
    },
  },
  methods: {
    getChanelType(){
      if(this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7){
        return 1;
      }if(this.currentWithdrawInfo.payTypeId == 5 || this.currentWithdrawInfo.payTypeId == 8){
        return 2;
      }if(this.currentWithdrawInfo.payTypeId == 6 || this.currentWithdrawInfo.payTypeId == 9){
        return 3;
      }
    },
    addHandle(){
      // 添加收款信息
      let channelType = this.getChanelType();

      this.$emit('add-collection',channelType);
      // this.$router.push({name: 'collection'});
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.withdraw-chanel-card {
  .payee-box {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid $themeColor;
    margin-bottom: 20px;
    position: relative;
    .card-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-img {
        width: 24px;
        height: 24px;
        margin-right: 15px;
      }
    }
    .bottom-line {
      padding-left: 40px;
      font-size: 14px;
    }

    .theNameOfTheCurrency{
      position: absolute;
      min-width: 48px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      right: 8px;
      border: 1px solid #E5E5E5;
      border-radius: 12px;
    }

    // 空信息
    &.no-info {
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      .add-btn {
        padding-right: 10px;
      }
    }
  }
  .trc20-text {
    padding-left: 36px;
  }
}
</style>
